import React from 'react';
import { useCookieConsent } from '../../contexts/CookieConsentContext';
import Icon from '../Icons';
import './styles.css';

const CookieConsentBanner = () => {
  const { showBanner, acceptAll, acceptEssential, openManagement } = useCookieConsent();

  if (!showBanner) return null;

  return (
    <div className="cookie-consent-banner">
      <div className="cookie-banner-content">
        <div className="cookie-banner-header">
          <div className="cookie-icon">
            <Icon name="cookie" size={24} />
          </div>
          <h3>We Value Your Privacy</h3>
        </div>
        
        <div className="cookie-banner-text">
          <p>
            We use cookies to enhance your experience, analyze site traffic, and personalize content. 
            By clicking "Accept All", you consent to our use of cookies. You can manage your preferences 
            or learn more in our <a href="/privacy-policy" target="_blank">Privacy Policy</a>.
          </p>
        </div>

        <div className="cookie-banner-actions">
          <button 
            className="cookie-btn cookie-btn-essential"
            onClick={acceptEssential}
          >
            <Icon name="shield" size={16} />
            Essential Only
          </button>
          
          <button 
            className="cookie-btn cookie-btn-manage"
            onClick={openManagement}
          >
            <Icon name="settings" size={16} />
            Manage Preferences
          </button>
          
          <button 
            className="cookie-btn cookie-btn-accept"
            onClick={acceptAll}
          >
            <Icon name="check" size={16} />
            Accept All
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieConsentBanner;
